import { useState } from "react";
import axios from "axios";
import { ShieldCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PrivacyRequest() {
  const w = new URLSearchParams(window.location.search).get("w");
  const [f, setF] = useState({ email: "", kind: "delete", note: "" });
  const [state, setState] = useState("form");
  const submit = async (e) => {
    e.preventDefault();
    setState("sending");
    try { await axios.post(`${API}/privacy/request${w ? `?w=${encodeURIComponent(w)}` : ""}`, f); setState("done"); } catch { setState("error"); }
  };
  const inp = "mt-1 w-full bg-black/40 border border-white/15 rounded-lg px-3 py-2.5 text-sm text-white focus:outline-none focus:border-white/50";
  return (
    <div className="min-h-screen bg-[#0B0D10] text-white flex items-center justify-center px-4" data-testid="privacy-page">
      <div className="w-full max-w-md bg-[#14171C] border border-white/10 rounded-2xl p-7">
        <p className="flex items-center gap-2 font-bold text-lg"><ShieldCheck className="w-5 h-5" /> Your verification data</p>
        {state === "done" ? <p className="mt-4 text-sm text-white/70" data-testid="privacy-done">Request received. We'll complete it within 30 days and confirm by email.</p> : (
          <form onSubmit={submit} className="mt-4 space-y-4">
            <p className="text-sm text-white/60">Ask us to delete your verification video, or to tell you what we hold about you.</p>
            <label className="block text-xs text-white/55">Email used at checkout<input required type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className={inp} data-testid="privacy-email" /></label>
            <label className="block text-xs text-white/55">Request
              <select value={f.kind} onChange={(e) => setF({ ...f, kind: e.target.value })} className={inp} data-testid="privacy-kind"><option value="delete">Delete my data</option><option value="access">Tell me what you hold</option></select>
            </label>
            <label className="block text-xs text-white/55">Note (optional)<textarea rows={2} maxLength={500} value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} className={inp} data-testid="privacy-note" /></label>
            {state === "error" && <p className="text-sm text-red-400" data-testid="privacy-error">Something went wrong. Please try again.</p>}
            <button disabled={state === "sending"} className="w-full py-3 rounded-xl bg-white text-black font-semibold disabled:opacity-50" data-testid="privacy-submit">Submit request</button>
            <p className="text-[11px] text-white/35">Recordings tied to an open payment dispute may be kept until the dispute closes.</p>
          </form>
        )}
      </div>
    </div>
  );
}
